// extracted by mini-css-extract-plugin
module.exports = {"ssoWrapper":"IntegratedHeader_ssoWrapper__If3T1"};